import './Footer.css'
import { FaPhoneVolume, FaClock, FaMapMarkerAlt, FaFacebookF, FaLinkedin, FaGithub } from 'react-icons/fa'
import { Link } from 'react-scroll'
import { Link as Linkto } from 'react-router-dom'

import house1 from '../../assets/rooms/1.png'
import house2 from '../../assets/rooms/2.png'
import house3 from '../../assets/rooms/3.png'
import house4 from '../../assets/rooms/4.png'
import house5 from '../../assets/rooms/5.png'
import house6 from '../../assets/rooms/6.png'

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="box">
          <h3>Homi</h3>
          <ul className="social">
            <li>
              <a href="https://www.facebook.com/profile.php?id=100042017311765&mibextid=ZbWKwL" className="facebook">
                <i><FaFacebookF /></i>
              </a>
            </li>
            <li>
              <a href="https://www.github.com/Rezkaudi" className="twitter">
                <i><FaGithub /></i>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/rezk-audi-987499267" className="linkedin">
                <i><FaLinkedin /></i>
              </a>
            </li>
          </ul>
          <p className="text">
            over 1 million+ homes for sale available on the website, we can match you with a house you will want to call home          </p>
        </div>
        <div className="box">
          <ul className="links">
            <li><Link spy={true} to="intro" smooth={true} activeClass='activeClass'>Intro</Link></li>
            <li><Link spy={true} to="about" smooth={true} activeClass='activeClass'>About</Link></li>
            <li><Link spy={true} to="services" smooth={true} activeClass='activeClass'>Services</Link></li>
            <li><Linkto to="list">List Of House</Linkto></li>
            <li><Link spy={true} to="stats" smooth={true} activeClass='activeClass'>State</Link></li>
          </ul>
        </div>
        <div className="box">
          <div className="line">
            <i><FaMapMarkerAlt /></i>
            <div className="info">Syria, Homs, Alarman</div>
          </div>
          <div className="line">
            <i><FaClock /></i>
            <div className="info">Business Hours: From 10:00 To 18:00</div>
          </div>
          <div className="line">
            <i><FaPhoneVolume /></i>
            <div className="info">
              <span>+963931817805</span>
              <span>+963931817805</span>
            </div>
          </div>
        </div>
        <div className="box footer-gallery">
          <img src={house1} loading='lazy' alt="house1" />
          <img src={house2} loading='lazy' alt="house2" />
          <img src={house3} loading='lazy' alt="house3" />
          <img src={house4} loading='lazy' alt="house4" />
          <img src={house5} loading='lazy' alt="house5" />
          <img src={house6} loading='lazy' alt="house6" />
        </div>
      </div>
      <p className="copyright">Made With &lt;3 By Rezk Audi</p>
    </div>
  )
}

export default Footer